"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Time;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TimeModule = _interopRequireDefault(require("./Time.module.scss"));

var _inputElements = require("../../../../../../inputElements");

var _Money = _interopRequireDefault(require("../../../../../../common/Money/Money"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
TODO: Tooltips:
Call
Rest
*/
// TODO: i18n
var timeOptions = [{
  value: "68",
  label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "1h ", /*#__PURE__*/_react.default.createElement(_Money.default, {
    moneyDivide: {
      pp: 0,
      gp: 68,
      cp: 0
    }
  }))
}, {
  value: "136",
  label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "2h ", /*#__PURE__*/_react.default.createElement(_Money.default, {
    moneyDivide: {
      pp: 0,
      gp: 136,
      cp: 0
    }
  }))
}, {
  value: "204",
  label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "3h ", /*#__PURE__*/_react.default.createElement(_Money.default, {
    moneyDivide: {
      pp: 0,
      gp: 204,
      cp: 0
    }
  }))
}, {
  value: "272",
  label: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "4h ", /*#__PURE__*/_react.default.createElement(_Money.default, {
    moneyDivide: {
      pp: 0,
      gp: 272,
      cp: 0
    }
  }))
}];

function Time(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_TimeModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _TimeModule.default.remaining
  }, "Remaining: 0:48:34"), /*#__PURE__*/_react.default.createElement("div", {
    className: _TimeModule.default.dropdown
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Select, {
    options: timeOptions,
    width: "86px"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _TimeModule.default.extendBtn
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.HIRING_RECOM_42X15
  }, "EXTEND")), /*#__PURE__*/_react.default.createElement("div", {
    className: _TimeModule.default.callBtn
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.HIRING_CALL_26X26
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _TimeModule.default.awayBtn
  }, /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.HIRING_REST_26X26
  })));
}